module.exports = __webpack_public_path__ + "static/media/meme-1.200df053.webp";